'use client';

import { Alert, Button, Container, Stack, Title, Text, Paper, Group, Box } from '@mantine/core';
import { IconAlertCircle, IconRefresh, IconHome } from '@tabler/icons-react';
import Link from 'next/link';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  return (
    <Container size="md" py="xl">
      <Stack gap="xl" align="center">
        <Paper p="xl" radius="lg" withBorder style={{ maxWidth: 500 }}>
          <Stack gap="lg" align="center" ta="center">
            <Box
              w={80}
              h={80}
              bg="red.6"
              style={{ 
                borderRadius: 'var(--mantine-radius-xl)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <IconAlertCircle size={40} color="white" />
            </Box>
            
            <Title order={1} size="2rem" fw={700} c="white">
              Something went wrong
            </Title>
            
            <Text size="lg" c="gray.3" maw={400}>
              We encountered an unexpected error. Please try again or contact support if the problem persists.
            </Text>

            <Alert 
              icon={<IconAlertCircle size={16} />} 
              title="Error Details" 
              color="red"
              variant="light"
              w="100%"
            >
              <Text size="sm" c="red.8">
                {error.message || 'An unknown error occurred'}
              </Text>
              {error.digest && (
                <Text size="xs" c="gray.5" mt="xs">
                  Error ID: {error.digest}
                </Text>
              )}
            </Alert>

            <Group gap="md">
              <Button 
                onClick={reset}
                leftSection={<IconRefresh size={16} />}
                size="lg"
                radius="md"
              >
                Try Again
              </Button>
              
              <Button 
                component={Link}
                href="/"
                variant="light"
                leftSection={<IconHome size={16} />}
                size="lg"
                radius="md"
              >
                Go Home
              </Button>
            </Group>
          </Stack>
        </Paper>
      </Stack>
    </Container>
  );
} 